import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils/request'

const initialState = {}

export const accountDelete = createAsyncThunk<any, any>(
  'accountDelete',
  async (arg) => {
    return req({
      url: '/api/account/apply_account_deletion',
      params: {...arg},
    })
  }
)

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {},
  extraReducers: () => {},
})

export default accountSlice.reducer
